import React, { useEffect } from "react";
import cookies from 'react-cookies';
import Layout from "./components/Layout/Layout";
import { Redirect, useHistory } from 'react-router-dom';
import { COOKIES, removeToken } from './helpers';
import { FeatureDisabledProvider } from './contexts/FeatureDisabledContext';
import FeatureDisabledModal from './components/FeatureDisabledModal';
import V2Migration from './components/V2Migration';
import { useFeatureDisabled } from './contexts/FeatureDisabledContext';

function AppContent() {
  const history = useHistory();
  const { isModalOpen, hideFeatureDisabledModal, showFeatureDisabledModal } = useFeatureDisabled();

  useEffect(() => {
    // Set the global reference for the modal trigger
    const { setFeatureDisabledModalRef } = require('./utils/featureDisabledHandler');
    setFeatureDisabledModalRef(showFeatureDisabledModal);
  }, [showFeatureDisabledModal]);

  // useEffect(() => {
  //   history.push('/');
  // }, []);

  const tokenValue = cookies.load(COOKIES.TOKEN);
  const token = !!tokenValue;

  if (!token) {
    return <Redirect to="/auth" />
  }

  // Validate JWT structure (must have 3 dot-separated segments)
  if (tokenValue.split('.').length !== 3) {
    removeToken();
    return <Redirect to="/auth" />
  }

  return (
    <>
      <V2Migration />
      <Layout/>
      <FeatureDisabledModal
        isOpen={isModalOpen}
        onClose={hideFeatureDisabledModal}
      />
    </>
  );
}

function App() {
  return (
    <FeatureDisabledProvider>
      <AppContent />
    </FeatureDisabledProvider>
  );
}

export default App;
